if (!customElements.get("add-to-recently-viewed")) {
  const MAX_ITEMS = 24;
  const EXCLUDED_HANDLES = new Set(["ukrasna-vrecica"]);

  const normalizeHandle = (value) => {
    if (!value) return "";

    let h = String(value).trim().toLowerCase();

    const match = h.match(/\/products\/([^\/\?#]+)/i);
    if (match && match[1]) return match[1].trim();

    return h.replace(/^\/+|\/+$/g, "");
  };

  const readList = (key) => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || "[]");
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  };

  const writeList = (key, list) => {
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch {

    }
  };

  const addToRecentlyViewed = (handle, key) => {
    const h = normalizeHandle(handle);
    if (!h || EXCLUDED_HANDLES.has(h)) return;

    const list = readList(key)
      .map(normalizeHandle)
      .filter((x) => x && !EXCLUDED_HANDLES.has(x) && x !== h);

    list.unshift(h);
    if (list.length > MAX_ITEMS) list.length = MAX_ITEMS;

    writeList(key, list);
  };

  customElements.define(
    "add-to-recently-viewed",
    class AddToRecentlyViewed extends HTMLElement {
      connectedCallback() {
        const shopId = this.dataset.shopId || "default";
        const key = `recently_viewed_handles_${shopId}`;

        const handle = this.dataset.handle || this.getAttribute("handle");
        addToRecentlyViewed(handle, key);
      }
    }
  );
}
